import Desktop from "homepage/Desktop";
import React from "react";
import { Link } from "react-router-dom";

export const HomeFooter = () => {
  return (
    <footer className="landing-footer bg-body footer-text">
      <div className="footer-top position-relative overflow-hidden z-1">
        <img
          src="../../assets/img/front-pages/backgrounds/footer-bg-light.png"
          alt="footer bg"
          className="footer-bg banner-bg-img z-n1"
          data-app-light-img="front-pages/backgrounds/footer-bg-light.png"
          data-app-dark-img="front-pages/backgrounds/footer-bg-dark.png"
        />
        <div className="container">
          <div className="row gx-0 gy-4 g-md-5">
            <div className="col-lg-5">
              <Link to="# " className="app-brand-link mb-4">
                <span className="app-brand-text demo footer-link fw-bold ms-2 ps-1">
                  Our Mission
                </span>
              </Link>
              <p
                className="footer-text footer-logo-description mb-4"
                style={{ textAlign: "justify" }}
              >
                At Zenosure, our mission is to make everyday healthcare and
                wellness more accessible, affordable, and rewarding. We connect
                individuals and families to a trusted network of hospitals,
                pharmacies, diagnostics, and wellness partners—delivering
                instant savings and a simpler path to better health.
              </p>
              {/* <form className="footer-form">
                <label htmlFor="footer-email" className="small">
                  Still we are able to see
                </label>
                <div className="d-flex mt-1">
                  <input
                    type="email"
                    className="form-control rounded-0 rounded-start-bottom rounded-start-top"
                    id="footer-email"
                    placeholder="Your email"
                  />
                  <button
                    type="submit"
                    className="btn btn-primary shadow-none rounded-0 rounded-end-bottom rounded-end-top"
                  >
                    Subscribe
                  </button>
                </div>
              </form> */}
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <h6 className="footer-title mb-4">Quick Links</h6>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <Link
                    to="/"
                    className="footer-link"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  >
                    Home
                  </Link>
                </li>
                {/* <li className="mb-3">
                  <Link href="#" className="footer-link">
                    Services
                  </Link>
                </li> */}
                {/* <li className="mb-3">
                      <Link
                        to="#"
                        className="footer-link"
                      >
                        Testimonials
                      </Link>
                    </li> */}
                <li className="mb-3">
                  <Link
                    to="/contactUs#"
                    className="footer-link"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  >
                    Contact us
                  </Link>
                </li>
                <li className="mb-3">
                  <Link
                    target={!Desktop ? "blank" : undefined}
                    to="/faq"
                    className="footer-link"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  >
                    FAQ
                  </Link>
                </li>
                <li className="mb-3">
                  <Link
                    to="/checkMembership"
                    className="footer-link"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  >
                    Check membership
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <h6 className="footer-title mb-4">Company</h6>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <Link
                    to="/partnerwithus"
                    className="footer-link"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  >
                    Partner with Us
                  </Link>
                </li>
                <li className="mb-3">
                  <Link
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                    target={!Desktop ? "blank" : undefined}
                    to="/termsConditions"
                    className="footer-link"
                  >
                    Terms and conditions
                  </Link>
                </li>
                <li className="mb-3">
                  <Link
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                    target={!Desktop ? "blank" : undefined}
                    to="/privacyPolicy"
                    className="footer-link"
                  >
                    Privacy policy
                  </Link>
                </li>
                {/* <li className="mb-3">
                  <Link
                    target={!Desktop ? "blank" : undefined}
                    to="/aboutus"
                    className="footer-link"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  >
                    About Us
                  </Link>
                </li>  */}
              </ul>
            </div>
            <div className="col-lg-3 col-md-4">
              <h6 className="footer-title mb-4">
                ZENOSURE DIGITAL PRIVATE LIMITED
              </h6>
              <p className="footer-text footer-logo-description ">
                CIN: U86900KA2024PTC183091
              </p>
              <p className="footer-text footer-logo-description ">
                456, 11th cross, Sadashivanagar, Bangalore, Karnataka, 560080
              </p>
              {/* <p className="footer-text footer-logo-description ">
                Bangalore Karnataka 560080
              </p> */}
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom py-3">
        <div className="container d-flex flex-wrap justify-content-between flex-md-row flex-column text-center text-md-start">
          <div className="mb-2 mb-md-0"></div>
          <div>
            <Link to="#" className="footer-link me-3">
              <img
                src="../../assets/img/front-pages/icons/github-light.png"
                alt="github icon"
                data-app-light-img="front-pages/icons/github-light.png"
                data-app-dark-img="front-pages/icons/github-dark.png"
              />
            </Link>
            <Link to="#" className="footer-link me-3">
              <img
                src="../../assets/img/front-pages/icons/facebook-light.png"
                alt="facebook icon"
                data-app-light-img="front-pages/icons/facebook-light.png"
                data-app-dark-img="front-pages/icons/facebook-dark.png"
              />
            </Link>
            <Link to="#" className="footer-link me-3">
              <img
                src="../../assets/img/front-pages/icons/twitter-light.png"
                alt="twitter icon"
                data-app-light-img="front-pages/icons/twitter-light.png"
                data-app-dark-img="front-pages/icons/twitter-dark.png"
              />
            </Link>
            <Link to="#" className="footer-link">
              <img
                src="../../assets/img/front-pages/icons/instagram-light.png"
                alt="google icon"
                data-app-light-img="front-pages/icons/instagram-light.png"
                data-app-dark-img="front-pages/icons/instagram-dark.png"
              />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
